import React, { Component } from 'react';
import './HandHistory.css';
import ReplayHand from '../HandReplayer/ReplayHand.js';
import HandReplayer from '../HandReplayer/HandReplayer.js';
import i18next from 'i18next';
import { DispatcherFunction } from 'mygame-components';
import { getCurrencySymbol, saveActivity } from "../../common/commonService";
//const baseUrlImage = "////mygame-dev.mypartypokerlive.com";
const baseUrlImage = "";

import { connect } from "react-redux";
class HandCard extends Component {

  constructor(props) {
    super(props)
    this.state = {
      openHandRep: false,
      staredHand: this.props.hand.staredHand,
      isSelected: false
    }
  }
  handReplayerOpen = () => {
    let gameType = this.props.hand.gameType==='Spin'?'spin':this.props.hand.gameType;
    if(window.messageToNative || (window.external && window.external.NativeDispatch)){
      DispatcherFunction("app:menu=3814&name=MYGAME_REPLAYER",{
        "MYGAME_REPLAYER_URL":'https://' + window.location.hostname +
        `/PopUpHandReplayer/${gameType}/${this.props.hand.gameNo}/${localStorage.getItem("accountName")}/${this.props.hand.fullDateTime? this.props.hand.fullDateTime: this.props.hand.time}`,
        "location":"yes",
        "height":"720",
        "width":"1000",
        "scrollbars":"yes",
        "status":"yes"
  })
  saveActivity({
    hit_page : 'MyHands',
    hit_type : 'MyHandsGameReplay',
    hit_attribute1 : this.props.hand.gameType,
    hit_attribute2 : this.props.hand.gameNo,
    hit_attribute3 : this.props.hand.fullDateTime? this.props.hand.fullDateTime: this.props.hand.time,
    hit_attribute4 : '',
    hit_attribute5 : '',
      })
}
    else{
    this.setState({ openHandRep: true });
  }
  }
  toggleStaredHand = () => {
    this.setState({ staredHand: !this.state.staredHand }, () => {
      this.props.setStarFlagOfHnad(this.props.hand, this.state.staredHand)
    });
  }

  render() {
    console.log("THIS>PROPSHAND CAR",this.props)
    let fullVersion = 0
    // console.log("navigator.appVersion", navigator.appVersion)
    if (navigator.appVersion.includes("Mac")) {
      if (navigator.appVersion.includes("Mobile")) {
        let osVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(navigator.appVersion);
        fullVersion = parseFloat(osVersion[1] + '.' + osVersion[2] + osVersion[3]);
        if (fullVersion > 12.10) {
          fullVersion = 13
        } else {
          fullVersion = 12
        }
      } else {
        let osVersion = /OS X (\d+)_(\d+)_?(\d+)?/.exec(navigator.appVersion);
        fullVersion = parseFloat(osVersion[1] + '.' + osVersion[2]);
        if (fullVersion > 10.13) {
          fullVersion = 13
        } else {
          fullVersion = 12
        }
      }
    } else {
      fullVersion = 13;
    }
    let hand = { ...this.props.hand }
    let isSelected = false;
    this.props.selectedHandList.map(handObj => {
      if (handObj.gameNo === hand.gameNo && handObj.fullDateTime === hand.fullDateTime) {
        isSelected = true;
        if (isSelected !== this.state.isSelected) {
          this.setState({ isSelected })
        }
      }
    })
    return (
      <div>
        {this.state.openHandRep ? <div style={{
          top: 0,
          left: 0,
          zIndex: 20000,
          width: "100%",
          height: "100%",
          overflow: "auto",
          position: "fixed",
          backgroundColor: '#2c2c34'
        }}>
          <style>{"\
        .navbar-fixed-top{\
          z-index:0 !important;\
        }\
      "}</style>
          {fullVersion && parseFloat(fullVersion) < 13 ? <HandReplayer
            replayerScreen={'desktop'}
            gameTypeForTitle={hand.gameType}
            onClose={() => this.setState({ openHandRep: false })}
            loginStatus={true}
            gameNo={hand.gameNo}
            accountName={localStorage.getItem('accountName')}
            // playerDtlsList={this.state.playerDtlsList}
            // actionDtlsList={this.state.actionDtlsList}
            // defaultPlayersList={this.state.defaultPlayersList}
            // defaultActionList={this.state.defaultActionList}
            partitionDate={hand.fullDateTime}
          // fromDate={repoSetting.fromDate}
          // toDate={repoSetting.toDate}
          // gameType={repoSetting.gameType}
          // rawData={this.state.rawData}
          /> :
            <ReplayHand
              replayerScreen={'desktop'}
              loginStatus={true}
              gameNo={hand.gameNo}
              partitionDate={hand.fullDateTime}
              accountName={localStorage.getItem('accountName')}
              // playerAlias={this.props.playerReports.playerName}
              gameTypeForTitle={hand.gameType}
              // fromDate={ repoSetting.fromDate}
              // toDate= {repoSetting.toDate}
              // gameType={repoSetting.gameType} 
              // i18next={i18next}
              onClose={() => this.setState({ openHandRep: false })}
            />}
        </div> : null}

        <div className="row padding-card-hand-histroy table-header-font vertical-align-card col-border-bottom">
          <div style={{ display: "flex", paddingLeft: 0, paddingRight: 0, marginRight: "-3%" }} className="col-md-2 col-xs-2 font-style-hand-history" >
            {this.state.isSelected !== undefined && <span className="MyHandshandCheckBox">
              <i onClick={() => {
                  if (isSelected) {
                    this.setState({isSelected: false})
                    this.props.unselectHand(hand)
                  } else {
                    this.setState({isSelected: true})
                    this.props.selectHand(hand)
                  }
              }}
                className={`MyHandsCheckBox fa fa-check ${(this.state.isSelected) ? " MyHandsCheckBoxSelected" : ""}`} aria-hidden="true"></i>
            </span>}
            <span>
              <span>{hand.time}</span><br />
              <span>{hand.date}</span>
            </span>
          </div>
          <div style={{ padding: 0 }} className="col-md-2 col-xs-2 HH_holeCards_margin" >
            {hand.pockeCard ? hand.pockeCard.map((card, i) =>
              <img key={i} className="box-shadow-card card-size" src={baseUrlImage + card} alt="" />
            ) : <div><span className="dark-card-size" />
                <span className="dark-card-size" /></div>}
          </div>
          <div style={{ padding: 0, marginRight: "-5%" }} className="col-md-2 col-xs-2" >
            {hand.flop ? hand.flop.map((card, i) =>
              <img key={i} className="box-shadow-card card-size" src={baseUrlImage + card} alt="" />
            ) : <div>
                <span className="dark-card-size" />
                <span className="dark-card-size" />
                <span className="dark-card-size" /></div>}
          </div>
          <div style={{ padding: 0, marginRight: "-2%" }} className="col-md-1 col-xs-1 HH_turn_padding"  >
            {hand.turn ? hand.turn.map((card, i) =>
              <img key={i} className="box-shadow-card card-size" src={baseUrlImage + card} alt="" />
            ) : <div><span className="dark-card-size" />
              </div>}
          </div>
          <div style={{ padding: 0 }} className="col-md-1 col-xs-1"  >
            {hand.river ? hand.river.map((card, i) =>
              <img key={i} className="box-shadow-card card-size" src={baseUrlImage + card} alt="" />
            ) : <div><span className="dark-card-size" />
              </div>}
          </div>
          <div style={{ padding: 0, marginLeft: "2%" }} className="col-md-1 col-xs-1 HH_position_value"  >{hand.position}</div>
          <div style={{ padding: 0 }} className="col-md-1 col-xs-1 amount-font-style"  >
            {hand.profit >= 0 ? hand.profit > 0 ? <span className='HH_amount-color amountPositionAbsolute'> {(hand.gameType != "cash") ? "" : `+ ${getCurrencySymbol(this.props.hand.currency)}`}{parseFloat(hand.profit).toFixed(2).toString().replace(".00", "")} {(hand.gameType != "cash")? "BB" : ""}</span> :
              <span className='HH_amount-color-grey amountPositionAbsolute'> {(hand.gameType != "cash") ? "" : getCurrencySymbol(this.props.hand.currency)}0 {(hand.gameType != "cash")? "BB" : ""}</span> :
              <span className='HH_amount-color-grey amountPositionAbsolute'> {(hand.gameType != "cash") ? "" : `- ${getCurrencySymbol(this.props.hand.currency)}`}{parseFloat(hand.profit).toFixed(2).toString().replace("-", "").replace(".00", "")} {(hand.gameType != "cash")? "BB" : ""}</span>}
          </div>
         

          <div className="col-md-2 col-xs-2 p-0-text-align-right HH_SNR_margin" >
            <div className="HH_SNR_wrapper">
            {!hand.cashedout? <span className='HH_SNR'>
              <img src={baseUrlImage+"/images/handReplay/cashout.png"}  width="30" height="30" hidden></img>
              </span> : <span className='HH_SNR'>
              <img src={baseUrlImage+"/images/handReplay/cashout.png"}  width="30" height="30"></img>
              </span>} 
              <span className="HH_SNR">
              
                <i style={{ fontSize: "22px", cursor: "pointer" }} onClick={this.toggleStaredHand} className={"staredHandColor " + (this.state.staredHand ? "fa fa-star" : "fa fa-star-o staredHandColorUnstar") + " MyHands_desktopstarPosition "}></i>
              </span>

              <span className="HH_SNR">
                {(hand.notes && hand.notes.length > 0) ? <span className="notecount">{hand.notes.length}</span> : null}
                <i data-e2e="hand notes" style={{ fontSize: "23px", cursor: "pointer" }}
                  data-toggle="modal"
                  data-target="#EditNoteModal"
                  onClick={(e) => {
                    e.preventDefault()
                    this.props.openNotes(hand)
                  }}
                  className={`staredHandColor edit_notePad ${(hand.notes && hand.notes.length > 0)
                    ? "fa fa-pencil-square padding_pencil_square"
                    : "fa fa-pencil-square-o staredHandColorUnstar"}`}>
                </i>
              </span>
              <span className="HH_SNR">
                <i data-e2e="replay" style={{ fontSize: "30px", cursor: "pointer" }} className="hoverScale fa fa-play-circle staredHandColor" onClick={this.handReplayerOpen}></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
const mapStateToProps = state => {
  return {
      selectedHandList: state.handHistory.selectedHandList,
      lang: state.header.lang
  }
}

export default connect(mapStateToProps, null)(HandCard);



/** WEBPACK FOOTER **
 ** ./src/components/HandHistory/HandCard.js
 **/